module.exports = __webpack_public_path__ + "static/media/pending-b-corp.2ca01424.png";